import List from 'list.js';

const options = {
  valueNames: [ 'name', 'description', 'categories']
};
 const nTaxList = new List('taxonomies', options)

function init() {
  const filters = document.querySelectorAll('.c-dropdown__input');

  if (!filters) {
    return;
  }

  document.querySelectorAll(".c-dropdown__option").forEach(function(option) {
    option.addEventListener('click', function() {
      buildQuery();
    });
  });

  document.querySelectorAll(".c-dropdown__trigger").forEach(function(trigger) {
    trigger.addEventListener('click', function() {
        if(trigger.parentNode.classList.contains('open')){
          buildQuery();
        }
    });
  });

}

function buildQuery(){

  const filters = document.querySelectorAll('.c-dropdown__input');
  Array.from(filters).forEach((filter) => {
    const value = filter.value;

     if(value != 'all') {
	    nTaxList.filter();
      nTaxList.filter(function(item) {
        const category_terms = item.values().categories.split(" ");
        let term_found = false;
        Array.from(category_terms).forEach((category_term) => {
          if(category_term == value) {
            term_found = true
          }
        })
        return term_found;
      });
     } else {
      nTaxList.filter()
     }
     
  });
  
  /*
  var $text = $(this).text();
  if($(this).hasClass( 'selected' )){
    userList.filter();
    $(this).removeClass('selected');
  } else {
    userList.filter(function(item) {
      return (item.values().born == $text);
    });
    $(this).addClass('selected');
  }
  */
}

export default init;
